<ng-template #deliveryBookingStatusChangeConfirmationModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-support-ticket-close-confirmation-modal" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2">
          <div class="text-center">
            @if (isCancelBooking) {
            <em class="mdi mdi-store-remove" style="font-size: 80px; color: #f06548"></em>
            } @else if (getDeliveryNextBookingStatus() !== helper.BookingStatus.ARRIVED_AT_DESTINATION && getDeliveryNextBookingStatus() !== helper.BookingStatus.ASSIGNED) {
            <em class="ri-store-2-fill" style="font-size: 80px; color: #f06548"></em>
            }
          </div>
          @if(getDeliveryNextBookingStatus() === helper.BookingStatus.ASSIGNED && !isCancelBooking) {
          <h4 class="text-center mb-3">
            @if(assignTo === helper.UserType.MERCHANT){
            {{ "heading-title.assign-merchant" | translate }}
            }@else{
            {{ "heading-title.assign-deliveryman" | translate }}
            }
          </h4>
          } @else {
          <div class="mt-2 pt-2 fs-15 mx-4 mx-sm-5 text-center">
            <h4>{{ "heading-title.are-you-sure" | translate }}</h4>
            @if (isCancelBooking) {
            <p>{{ "label-title.you-want-to-change-the-booking-status-to-status" | translate : { _STATUS: getCancelBookingString() } }}</p>
            }@else {
            <p>{{ "label-title.you-want-to-change-the-booking-status-to-status" | translate : { _STATUS: getDeliveryStatusButtonString() } }}</p>
            }
          </div>
          }
          <form [formGroup]="completeBookingDetailsForm">
            <div class="row">
              <!-- for complete booking start -->
              @if (getDeliveryNextBookingStatus() === helper.BookingStatus.ARRIVED_AT_DESTINATION && !isCancelBooking && !isBookingTypePickUp()) {
              <div class="col-12 mb-2">
                <label for="booking-complete-address">{{ "label-title.address" | translate }}</label>
                <input
                  class="form-control"
                  id="booking-complete-address"
                  formControlName="completeAddress"
                  placeholder="{{ 'label-title.enter-address' | translate }}"
                  (input)="onCompleteAddressInputChange($event)"
                  autocomplete="off"
                />
                @if(completedAddressPredictions.length > 0) {
                <ul class="autocomplete-dropdown" id="complete-address-autocomplete-google-dropdown">
                  @for (prediction of completedAddressPredictions; track $index) {
                  <li class="text-ellipsis" [class.selected]="isCompletedAddressSelected($index)" id="complete-address-autocomplete-google-dropdown-item-{{ $index }}">
                    <a href="javascript:void(0);" (click)="onPredictionSelect(prediction)">{{ prediction.description }}</a>
                  </li>
                  }
                  <img src="../../../../assets/images/default-images/google_images/google_on_white.png" alt="Google Logo" class="p-2" />
                </ul>
                } @if (completedAddressMapBoxSuggestions.length > 0) {
                <ul class="autocomplete-dropdown" id="complete-address-autocomplete-mapbox-dropdown">
                  @for (suggestion of completedAddressMapBoxSuggestions; track $index) {
                  <li [class.selected]="isCompletedAddressSelected($index)" id="complete-address-autocomplete-mapbox-dropdown-item-{{ $index }}">
                    <a href="javascript:void(0);" (click)="onSelect(suggestion)">{{ suggestion.place_name }}</a>
                  </li>
                  }
                </ul>
                } @if(completeBookingDetailsForm.get('completeAddress')?.errors && completeBookingDetailsForm.get('completeAddress')?.touched &&
                completeBookingDetailsForm.get('completeAddress')?.errors?.['required']){
                <div class="invalid-message">
                  <p class="m-0">{{ "label-title.address" | translate }} {{ "label-title.is-required" | translate }}</p>
                </div>
                }
              </div>
              }
              <!-- for complete booking end -->
  
              <!-- for assign driver start -->
              @if(getDeliveryNextBookingStatus() === helper.BookingStatus.ASSIGNED && !isCancelBooking) {
              <div class="col-12 mb-2">
                <label for="booking-driver-selection">
                  @if(assignTo === helper.UserType.MERCHANT){
                  {{ "label-title.merchant" | translate }}
                  }@else{
                  {{ "label-title.driver" | translate }}
                  }
                </label>
                <ng-select
                  id="booking-driver-selection"
                  notFoundText="{{ 'label-title.no-record-found' | translate }}"
                  appearance="outline"
                  labelForId="type"
                  [searchable]="true"
                  [clearable]="false"
                  placeholder="{{ 'label-title.select-driver' | translate }}"
                  formControlName="driverId"
                >
                  @for (driver of driverList; track $index) { @if(driver.name){
                  <ng-option [value]="driver._id">{{ driver.name }}</ng-option>
                  }@else{
                  <ng-option [value]="driver._id">{{ driver.firstName }} {{ driver.lastName }}</ng-option>
                  } }
                </ng-select>
                @if(completeBookingDetailsForm.get('driverId')?.errors && completeBookingDetailsForm.get('driverId')?.touched &&
                completeBookingDetailsForm.get('driverId')?.errors?.['required']){
                <div class="invalid-message">
                  <p class="m-0">{{ "label-title.driver" | translate }} {{ "label-title.is-required" | translate }}</p>
                </div>
                }
              </div>
              }
              <!-- for assign driver end -->
  
              <!-- for cancle booking start -->
              @if (isCancelBooking) {
              <div class="col-12 mb-2">
                <label for="booking-cancellation-reason">{{ "label-title.cancellation-reason" | translate }}</label>
                <ng-select
                  id="booking-cancellation-reason"
                  notFoundText="{{ 'label-title.no-data-found' | translate }}"
                  appearance="outline"
                  labelForId="type"
                  [searchable]="true"
                  [clearable]="false"
                  placeholder="{{ 'label-title.enter-cancellation-reason' | translate }}"
                  formControlName="cancellationReason"
                  (change)="setSpecificReasonValidators()"
                >
                  @for (cancelBookingReason of cancelBookingReasonList; track $index) {
                  <ng-option [value]="cancelBookingReason.reasons[helper.cuurentLang]">{{ cancelBookingReason.reasons[helper.cuurentLang] }}</ng-option>
                  }
                  <ng-option [value]="'Other'">{{ "label-title.other" | translate }}</ng-option>
                </ng-select>
                @if(completeBookingDetailsForm.get('cancellationReason')?.errors && completeBookingDetailsForm.get('cancellationReason')?.touched &&
                completeBookingDetailsForm.get('cancellationReason')?.errors?.['required']){
                <div class="invalid-message">
                  <p class="m-0">{{ "label-title.cancellation-reason" | translate }} {{ "label-title.is-required" | translate }}</p>
                </div>
                }
              </div>
  
              <div class="col-12 mb-2">
                @if(completeBookingDetailsForm.value.cancellationReason === "Other") {
                <div class="">
                  <input
                    class="form-control"
                    type="text"
                    id="specificReason"
                    autocomplete="off"
                    formControlName="specificReason"
                    placeholder="{{ 'label-title.write-specific-reason' | translate }}"
                    (keypress)="helper.spaceValidation($event)"
                  />
  
                  @if (specificReasonInput?.invalid && specificReasonInput?.touched) {
                  <div class="invalid-message">
                    @if (specificReasonInput?.hasError('required')) {
                    <p class="m-0">{{ "label-title.reason" | translate }} {{ "label-title.is-required" | translate }}</p>
                    }
                  </div>
                  }
                </div>
                }
              </div>
              }
              <!-- for cancle booking end -->
  
              @if (getDeliveryNextBookingStatus() === helper.BookingStatus.PICKED || getDeliveryNextBookingStatus() === helper.BookingStatus.STARTED || getDeliveryNextBookingStatus()
              === helper.BookingStatus.ARRIVED_NEAR_DESTINATION || getDeliveryNextBookingStatus() === helper.BookingStatus.ARRIVED_AT_DESTINATION) {
              <div class="col-12 mb-2">
                <label for="qc-booking-complete-note">{{ "label-title.note" | translate }}</label>
                <input class="form-control" id="qc-booking-complete-note" formControlName="note" placeholder="{{ 'label-title.enter-note' | translate }}" autocomplete="off" />
              </div>
              }
            </div>
          </form>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            id="close-support-ticket"
            class="btn w-sm btn-danger btn-load d-flex align-items-center justify-content-center"
            style="overflow: unset"
            [ngClass]="{ 'pointer-events-none': helper.showBtnLoader[1] }"
            (click)="isCancelBooking ? cancelBooking() : updateBookingStatus()"
          >
            <span class="d-flex align-items-center" id="close-support-ticket-button">
              @if (helper.showBtnLoader[1]) {
              <span class="spinner-border flex-shrink-0">
                <span class="visually-hidden"></span>
              </span>
              } @else {
              <span class="flex-grow-1" [ngClass]="{ 'ms-2': helper.showBtnLoader[1] }" id="close-support-ticket-button-text">
                @if (isCancelBooking) {
                {{ "button-title.yes-cancel-it" | translate }}
                } @else if (getDeliveryNextBookingStatus() === helper.BookingStatus.ASSIGNED) {
                {{ "button-title.yes-assign-it" | translate }}
                } @else if (getDeliveryNextBookingStatus() !== helper.BookingStatus.ARRIVED_AT_DESTINATION) {
                {{ "button-title.yes-change-it" | translate }}
                } @else {
                {{ "button-title.yes-complete-it" | translate }}
                }
              </span>
              }
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  